import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';

export const editCurrentPharmacyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/user/pharmacy',
}).lazy(() => import('pages/shared/Profile/PharmacyPage/PharmacyPage').then((d) => d.Route));
